export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Join Our Waitlist',
      description: 'Fill out our simple waitlist form with your rental preferences, budget, and timeline. This helps us match you with the perfect property when it becomes available.'
    },
    {
      number: '02',
      title: 'Get Notified First',
      description: 'Be among the first to know when properties matching your criteria become available. We\'ll contact you with details and schedule viewings at your convenience.'
    },
    {
      number: '03',
      title: 'Submit Application',
      description: 'Found your perfect home? Complete our straightforward rental application. We review all applications fairly and provide quick decisions.'
    },
    {
      number: '04',
      title: 'Move In',
      description: 'Once approved, we\'ll coordinate your move-in date, complete the lease signing, and hand over the keys to your new home. Welcome home!'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            How It Works
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Our streamlined rental process makes finding and securing your next home simple and stress-free.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 h-full">
                <div className="text-6xl font-bold text-teal-100 mb-4">{step.number}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-teal-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
